import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            d: "M0 0H40V40H0z",
            transform: "translate(-1304 -344) translate(1304 344)"
          }),
          _createElementVNode("path", {
            fill: "#FFF",
            d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm0 2.5C10.335 2.5 2.5 10.335 2.5 20S10.335 37.5 20 37.5 37.5 29.665 37.5 20 29.665 2.5 20 2.5zM24.812 9C25.468 9 26 9.534 26 10.193s-.532 1.193-1.188 1.193h-2.817c-.996 0-1.805.812-1.805 1.81v3.182h4.06c.657 0 1.189.534 1.189 1.192 0 .66-.532 1.193-1.189 1.193h-4.06v11.044C20.19 30.466 19.658 31 19 31c-.656 0-1.188-.534-1.188-1.193V18.763h-2.625c-.656 0-1.188-.534-1.188-1.193 0-.658.532-1.192 1.188-1.192h2.625v-3.181c0-2.314 1.876-4.197 4.182-4.197z",
            transform: "translate(-1304 -344) translate(1304 344)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }